// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./tutorial/PageFlag.css
// module id = 2060
// module chunks = 3